import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import { space, tokPx } from '@sunwebgroup/ui-components'
import { Button, Sheet, useBreakpoints } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const TextTruncate = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
  max-width: ${tokPx('primitives_area_size_720')};
  min-width: ${tokPx('primitives_area_size_240')};
  margin-top: ${space('primitives_space_16')};
`

export function ReadMore({ children }: React.PropsWithChildren) {
  const [isSheetOpen, setSheetOpen] = React.useState(false)
  const intl = useIntl()
  const { isTablet } = useBreakpoints()
  const { sendEvent } = useAnalytics()

  const handleOpenChange = (open: boolean) => {
    setSheetOpen(open)

    if (open) {
      sendEvent(
        createPDPClickEvent({
          element: 'Clickable text',
          description: 'Show more text about acco info',
          result: 'all acco info shown',
          type: 'show more',
        }),
      )
    }
  }

  return (
    <>
      {/* @ts-expect-error: inert as a boolean is not fully supported in React. It work fine in React 19 */}
      <TextTruncate inert="">
        {children}
      </TextTruncate>
      <Sheet.Root open={isSheetOpen} onOpenChange={handleOpenChange}>
        <Sheet.Trigger>
          <Button $size="M" $type="transparentPrimary">
            {intl.formatMessage({ id: 'description_read_more' })}
          </Button>
        </Sheet.Trigger>
        <Sheet.Body side={isTablet ? 'right' : 'bottom'}>
          <Sheet.Header
            closeLabel={intl.formatMessage({ id: 'close' })}
            titleLabel={intl.formatMessage({ id: 'about_accommodation_title' })}
          />
          <Sheet.Content>
            {children}
          </Sheet.Content>
        </Sheet.Body>
      </Sheet.Root>
    </>
  )
}
